import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import { LOCAL_STORAGE_KEYS } from "../config/local_storage_keys";
import SubscriptionsModal from "../ui/subscriptions/SubscriptionsModal";

interface SubscriptionsModalContextType {
  open: () => void;
  close: () => void;
}

const SubscriptionsModalContext = createContext<
  SubscriptionsModalContextType | undefined
>(undefined);

export function useSubscriptionsModal() {
  const ctx = useContext(SubscriptionsModalContext);
  if (!ctx)
    throw new Error(
      "useSubscriptionsModal must be used within a SubscriptionsModalProvider"
    );
  return ctx;
}

export function SubscriptionsModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    // Save the current URL to localStorage when opening the modal
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL,
      window.location.href
    );
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL);
    setIsOpen(false);
  }, []);

  return (
    <SubscriptionsModalContext.Provider value={{ open, close }}>
      {children}
      {isOpen && <SubscriptionsModal onClose={close} />}
    </SubscriptionsModalContext.Provider>
  );
}
